import { Injectable } from "@angular/core";

import { PageStorageService } from "./page-storage.service";


// Tab-pagina's gebruiken exact dezelfde frame-node als gewone pagina's; de aparte klasse blijft
// bestaan omdat componenten hem als eigen DI-token providen (vaak met PageStorageService als alias).
@Injectable()
export class TabPageStorageService
    extends PageStorageService
{
}
